module.exports = __webpack_public_path__ + "static/media/Logo4x.1354cee7.png";